import { TranslateFunction } from 'deckard-ui/dist/utils/translator';
import kebabCase from 'lodash/kebabCase';
import { PathTypedColDefGroup } from './types';

export function columnGroupAttributesCreator(
  translate: TranslateFunction
): (headerName: string) => Omit<PathTypedColDefGroup, 'children'> {
  return (headerName) => {
    const translatedHeaderName = translate(headerName);
    return {
      headerName: translatedHeaderName,
      /**
       * Unlike columns, the "col-id" attribute must be set through this "groupId" field.
       * However, note that AG Grid will append "_<NUMBER>" to the string provided.
       */
      groupId: kebabCase(translatedHeaderName),
    };
  };
}
